/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const stylesHeader = theme => ({
  navMenuDropdown: {
    minWidth: '180px',
    padding: '8px',
    border: '1px solid #D5D6D7',
    boxShadow: 'none',
    borderRadius: '0px',
    marginTop: '2px',
  },
  menuList: {
    padding: '0px',
    '& .MuiListItem-root': {
      borderTop: '1px solid  #D5D6D7',
      padding: '16px',

      '&:nth-child(1)': {
        border: 'none',
      },
      '&:hover': {
        background: 'none',
        color: theme.palette.primary.adgmHover,
      },
    },
  },
  submitBtnholder: {
    display: 'flex',
    padding: '8px 0 0',
    justifyContent: 'space-between',
  },
  appDeatailsHeader: {},
  returnHintText: {
    fontSize: '14px',
  },
  margin_x: {
    marginRight: '8px',
  },
  feedbackmodalBtnholder: {
    display: 'flex',
    justifyContent: 'flex-end',
    textAlign: 'right',
    marginTop: '16px',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      justifyContent: 'center',
      marginTop: '40px',
    },
  },
  btns: {
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    },
  },
  accptBtn: {
    fontSize: '16px',
    color: '#fff',
    background: theme.palette.primary.main,
    height: '60px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px !important',
      fontSize: '14px !important',
      height: '50px !important',
    },
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      border: 'none',
    },
    '&:focus': {
      border: 'none',
      background: theme.palette.primary.adgmHover,
    },
  },
  editBtn: {
    width: '75%',
    height: '50px',
    maxWidth: '300px',
    marginBottom: '16px',
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '0px',
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      border: 'none',
    },
  },
  cancelBtn: {
    width: '75%',
    height: '50px',
    maxWidth: '300px',
    marginBottom: '16px',
    fontSize: '16px',
    color: '#342D3D',
    textTransform: 'none',
    borderRadius: '0px',
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      border: 'none',
    },
  },
  rejectBtn: {
    fontSize: '16px',
    color: '#342D3D',
    height: '60px',
    minWidth: '151px',
    border: '1px solid #342D3D',
    textTransform: 'none',
    marginRight: '16px',
    borderRadius: '0px',
    transition: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px !important',
      height: '50px !important',
    },
    '& svg': {
      marginRight: '8px',
    },
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      border: 'none',
      color: '#fff',
      transition: 'none',
      '& svg path': {
        stroke: '#fff',
      },
      '& img': {
        filter: 'invert(1)',
      },
    },
  },
  rejectBtnMenu: {
    fontSize: '16px',
    color: '#342D3D',
    height: '60px',
    minWidth: '200px',
    border: '1px solid #342D3D',
    textTransform: 'none',
    marginRight: '16px',
    borderRadius: '0px',
    transition: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px !important',
      height: '50px !important',
    },
    '& svg': {
      marginLeft: '8px',
    },
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      border: 'none',
      color: '#fff',
      transition: 'none',
      '& svg path': {
        stroke: '#fff',
      },
      '& img': {
        filter: 'invert(1)',
      },
    },
  },
  rejectApplicationbtn: {
    transition: 'none',
    textTransform: 'none',
    color: '#D2374F',
    fontSize: '16px',
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
    },
    '&:hover': {
      background: 'transparent',
    },
  },

  breadcrumbs: {
    fontSize: '12px',
    '& li': {
      padding: '0',
      border: '0',
    },
    '& a': {
      color: '#1C999B',
      textDecoration: 'none',
      '& svg': {
        fontSize: '18px',
      },
    },
    '& $activelink': {
      color: '#8C9099',
    },
  },
  activelink: {},

  textGray: {},

  modalpaper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: '#fff',
    padding: '24px',
    fontSize: '16px',
  },
  dimColor: {
    color: '#8C9099',
  },
  darkgreen: {
    color: '#fff',
    background: '#1C999B',
  },
  warning: {
    color: theme.palette.primary.warningMango,
    border: `1px solid ${theme.palette.primary.warningMango}`,
    background: theme.palette.primary.warningMangoLight,
  },
  initibadges: {
    marginLeft: '5px',
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '784px',
    position: 'relative',
    '& $Title': {
      marginBottom: '32px',
    },
    '& $crossIconimg': {
      position: 'absolute',
      right: '24px',
      top: '31px',
    },
    '& $unitinputControl': {
      '& p': {
        display: 'block',
        marginBottom: '9px',
        fontWeight: '400',
        color: '#8C9099',
        fontSize: '14px',
        '& span': {
          color: '#8C9099',
          fontSize: '14px',
        },
      },
      '& textarea': {
        outline: 'unset',
        padding: '21px 16px',
        width: '100%',
        border: '1px solid #CED1D6',
        minHeight: '160px',
        fontSize: '16px',
        resize: 'none',
        [theme.breakpoints.down('sm')]: {
          height: '100% !important',
        },
      },
      '& fieldset': {
        border: '1px solid #CED1D6',
        borderRadius: '4px',
      },
    },
    '& $formControl': {
      gridTemplateColumns: '1fr',
    },
    '& $modaltitlehead': {
      display: 'block',
      '& img': {
        display: 'none',
      },
    },
  },
  modaltitlehead: {},
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '28px',
  },
  TitleV2: {
    fontWeight: '600',
    fontSize: '16px',
  },
  headerV2: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '& img': {
      width: '75px',
    },
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
      '& img': {
        width: '40px',
      },
    },
  },
  headerContentV2: {
    display: 'flex',
    flexDirection: 'column',
    '& >h1': {
      fontSize: '24px',
      fontWeight: '600',
    },
    '& > img': {
      width: '75px',
    },
    [theme.breakpoints.down('sm')]: {
      '& >h1': {
        fontSize: '12px',
        fontWeight: '500',
      },
      '& >p': {
        fontSize: '12px',
        fontWeight: '500',
      },
    },
  },
  tenantRejectTitle: {
    fontWeight: '600',
    fontSize: '16px',
    '& $required': {
      color: theme.palette.primary.errorRedNew,
    },
  },
  required: {},
  tenantRejectTitleV2: {
    fontWeight: '600',
    fontSize: '18px',
  },
  subTitle: {
    fontWeight: '600',
    fontSize: '18px',
  },
  formControl: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '16px',
    flex: '1',
  },
  modalBtnholder: {
    display: 'flex',
    justifyContent: 'spaceBetween',
    alignItems: 'center',
    textAlign: 'center',
    gap: '40px',
  },
  submitBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '60px',
    minWidth: '213px',
    textTransform: 'none',
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      border: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
  },
  submitBtnV2: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '50px',
    minWidth: '170px',
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '&:hover': {
      border: 'none',
      background: theme.palette.primary.adgmHover,
    },
  },
  unitinputControl: {
    '& > p': {
      display: 'block',
      marginBottom: '9px',
      fontWeight: '500',
      '& span': {
        color: '#D2374F',
        fontSize: '18px',
      },
    },
    '& input': {
      padding: '17px 16px',
      '&:valid:focus + fieldset': {
        borderColor: '#342D3D',
        borderWidth: '1px',
      },
    },
    '& fieldset': {
      border: '1px solid #CED1D6',
      borderRadius: '10px',
    },
  },
  colorRed: {
    '& textarea': {
      border: `1px solid ${theme.palette.primary.errorRedNew} !important`,
    },
  },
  griditem: {},
  imgHolder: {
    textAlign: 'center',
  },
  sentTextTitle: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#342D3D',
  },
  sentTextSubTitle: {
    fontSize: '16px',
    fontWeight: '500',
  },
  rejectModal: {
    fontSize: '14px',
    fontWeight: '400',
    color: '#8C9099',
  },
  innerModalAccept: {
    position: 'relative',
    '& $crossIconimg': {
      position: 'absolute',
      right: '0',
      top: '0',
    },
    '& h1': {
      marginBottom: '24px',
      fontSize: '20px',
    },
    '& h2': {
      marginBottom: '28px',
      fontWeight: '400',
      fontSize: '16px',
    },
  },
  crossIconimg: {},
  checkboxHolder: {
    paddingTop: '20px',
    '& $btnholder': {
      paddingLeft: '28px',
    },
  },
  acceptcheckboxLabel: {
    marginBottom: '20px',
    alignItems: 'flex-start',
    color: '#342D3D',
    '& span': {
      color: '#342D3D',
      paddingTop: '0',
    },
    '& input:checked + svg': {
      color: '#1FCACC',
    },
  },
  btnProceedpayment: {
    background: theme.palette.primary.main,
    color: '#fff',
    fontSize: '16px',
    fontWeight: '600',
    display: 'block',
    width: '100%',
    height: '48px',
  },
  btnholder: {},
  gotoHomeBtn: {
    display: 'block',
    height: '48px',
    background: theme.palette.primary.main,
    color: '#fff',
    fontWeight: '600',
    fontSize: '16px',
    width: '75%',
    marginTop: '32px',
    marginLeft: '49px',
    textTransform: 'none',
  },
  initiateserviceSect: {
    marginTop: '19px',
    marginBottom: '19px',
    alignItems: 'flex-start',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: '-20px !important',
      borderTop: '2px solid #EBEEF3',
      left: '0',
      backgroundColor: '#fff',
      zIndex: '999',
      '&:last-child': {
        borderBottom: '0',
        marginBottom: '0',
      },
      '& $appDeatailsHeader': {
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
    },
    [theme.breakpoints.down('xs')]: {
      bottom: '45px !important',
    },
  },
  AboveSectionBtns: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 0',
    fontWeight: '600',
    justifyContent: 'flex-start',
    width: '100%',
    background: 'none',
  },
  return: {},
  reject: {},
  CTARejectReturnAboveBtnsSection: {
    position: 'absolute',
    bottom: '66px',
    right: '0',
    background: '#fff',
    width: '100%',
    height: '100px',
    zIndex: '999',
    boxShadow: '0px -14px 20px 0px rgb(0 0 0 / 14%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '1rem',
    borderBottom: '2px solid #EBEEF3',
    '& $return': {
      borderBottom: '2px solid #EBEEF3',
    },
    '& $reject': {
      color: '#DF2C2C',
    },
  },
  initiateservicedtaile: {
    display: 'grid',
    gridTemplateColumns: '61px auto',
    gap: '9px',
    '& img': {
      display: 'block',
      width: '100%',
    },
  },
  modalAccptBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '48px',
    minWidth: '151px',
    marginRight: '16px',
    textTransform: 'none',
    padding: '0px 80px',
    '&:hover': {
      border: 'none',
      background: theme.palette.primary.adgmHover,
    },
    textWrap: 'noWrap',
  },
  TerminateBtn: {
    fontSize: '16px',
    color: theme.palette.primary.main,
    height: '48px',
    minWidth: '151px',
    border: `1px solid ${theme.palette.primary.main}`,
    textTransform: 'none',
    transition: 'none',
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      border: 'none',
      color: '#fff',
    },
  },
  contractCancellationModal: {
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '1.7',
    '& $imgHolder': {
      marginBottom: '20px',
    },
    '& h2': {
      fontSize: '20px',
      fontWeight: '600',
      marginBottom: '10px',
    },
  },
  returnAndRejectmodal: {
    padding: '0',
    bottom: '67px !important',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    '& > div': {
      '&:first-child': {
        bottom: '67px !important',
        top: 0,
      },
    },
  },
  RRcollapseList: {
    background: '#fff',
    borderRadius: '10px 10px 0 0',
    boxShadow: '0px -1px 8px rgba(0, 0, 0, 0.1)',
    '& $ListItem': {
      borderBottom: '1px solid #EBEEF3',
      color: '#130F26',
      fontWeight: '600',
      fontSize: '14px',
      '& span': {
        fontWeight: '600',
        fontSize: '14px',
      },
      '&:last-child': {
        borderBottom: '0',
      },
    },
    '& $ListItemIcon': {
      minWidth: 'auto',
      marginRight: '8px',
      color: '#130F26',
      '& svg': {
        fontSize: '19px',
      },
    },
    '& $rejectListItem': {
      color: '#D2374F',
      '& $ListItemIcon': {
        color: '#D2374F',
      },
    },
  },
  ListItem: {},
  ListItemIcon: {},
  rejectListItem: {},
  [theme.breakpoints.up('md')]: {
    Title: {
      fontSize: '24px',
    },
    subTitle: {
      fontSize: '18px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    accptBtn: {
      width: '100%',
      // marginTop: '10px',
    },
    rejectBtn: {
      width: '100%',
    },
    modal: {
      width: '95%',
      height: '97%',
      top: '50%',
    },
  },
  CTAButtons: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      paddingLeft: '16px !important',
      paddingRight: '16px !important',
      background: '#fff',
    },
  },

  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
  },
  hintBar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  requiredRed: {
    color: theme.palette.primary.errorRedNew,
  },
  // Property Header
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0px',
    },
  },
  propertyDetailsContainer: {
    display: 'flex',
  },
  imgCls: {
    marginRight: '16px',
  },
  headerImage: {
    width: '100%',
    height: '100px',
    [theme.breakpoints.down('sm')]: {
      width: '72px',
      height: '72px',
    },
  },
  title: {
    fontWeight: '600',
    fontSize: '28px',
    display: 'flex',
    gap: '5px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  chip: {
    background: '#237E7C',
    color: '#fff',
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    height: '27px',
    fontWeight: '500',
    margin: '6px',
    [theme.breakpoints.down('sm')]: {
      margin: '0px 5px',
    },
  },
  subInfo: {
    fontWeight: '600',
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  badgeContainer: {
    display: 'flex',
    marginTop: '5px',
  },

  mainBtnholdaer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    textAlign: 'left',
    gap: '22px',
    '& $btnHolder': {
      minWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        minWidth: '197px',
      },
    },
  },

  [theme.breakpoints.down('xs')]: {
    mainBtnholdaer: {
      '& $chipHolder': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: '15px',
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    mainBtnholdaer: {
      textAlign: 'right',
      justifyContent: 'flex-end',
    },
  },
});

export default stylesHeader;
